import { useGetSchemeListSchemeGet } from "kubb";
import type React from "react";
import { useContext, useEffect } from "react";
import { useSelectedCompany } from "../../reducers/company";
import { SchemeContext } from "../../reducers/scheme";
import SchemeSelectInit from "./SchemeSelectInit";

const InnerSchemeListInit = (props: {
  children: React.ReactNode;
}): React.ReactElement => {
  const { state, dispatch } = useContext(SchemeContext);
  const { stale } = state;
  const selectedCompany = useSelectedCompany();

  if (!selectedCompany) {
    throw new Error("Company must have been selected.");
  }
  const { data, isPending, error, refetch } = useGetSchemeListSchemeGet(
    {
      company_id: selectedCompany.company_id,
    },
    {
      query: {
        staleTime: 5 * 60 * 1000,
      },
    },
  );

  useEffect(() => {
    if (data?.data) {
      dispatch({ type: "LOADING_SCHEMES_SUCCESS", payload: data.data });
    }
  }, [data, dispatch]);

  useEffect(() => {
    if (isPending && !stale) {
      console.log("Loading schemes started");
      dispatch({ type: "LOADING_SCHEMES_STARTED" });
    }
  }, [isPending, dispatch, stale]);

  useEffect(() => {
    if (error) {
      dispatch({ type: "LOADING_SCHEMES_ERROR", payload: error });
    }
  }, [error, dispatch]);
  useEffect(() => {
    console.log("stale");
    if (stale) {
      refetch();
    }
  }, [stale, refetch]);

  return (
    <>
      <SchemeSelectInit>{props.children}</SchemeSelectInit>
    </>
  );
};

export default function SchemeListInit(props: {
  children: React.ReactNode;
}): React.ReactElement {
  const selectedCompany = useSelectedCompany();
  const { dispatch } = useContext(SchemeContext);

  useEffect(() => {
    if (!selectedCompany) {
      dispatch({ type: "LOADING_SCHEMES_SUCCESS", payload: [] });
    }
  }, [selectedCompany, dispatch]);

  return (
    <>
      {selectedCompany ? (
        <InnerSchemeListInit>{props.children}</InnerSchemeListInit>
      ) : (
        <>{props.children}</>
      )}
    </>
  );
}
